import React, { Component } from 'react'
import { checkTranslation, imageAddress } from '../../../../utils/useful'
import Responsive from '../../../Responsive'

export default class FileMedia extends Component {
    state = {
        media: {}
    }
    componentDidMount() {
        this.props.filterMedia('file')
    }
    render() {
        return (
            <div className="w-100 h-100 scroll-no-scrollbar">
                <div className="d-flex flex-wrap m-0 w-100 p-2 h-100">
                    {this.props.media?.file?.map((element) => {
                        console.log('fileeeeeee', element)
                        return (
                            <Responsive className={'px-1 py-1'} width={this.props.width} media={{ xs: "12", }}>
                                <div className='poistion-relative flexc cursor-pointer hover-gray p-1 br-5'>
                                    <img src='/assets/icons/doc-fill-blue.svg' />
                                    <p className='font-size-12'>{checkTranslation(element.file.orgName)}</p>
                                </div>
                            </Responsive>
                        )
                    })}
                </div>
            </div>
        )
    }
}
